import {PageHeader} from "../../../../lib/src/components/content/PageHeader";
import {Paragraph} from "../../../../lib/src/components/Paragraph";
import {Broadcast, useApiCall, useApiEndpoint} from "../../../../lib/src/api";
import {config} from "../../config";
import {TussenOnsBroadcastCard} from "../../components/tussen-ons/TussenOnsBroadcastCard";
import {Button} from "@jane/lib/src/components/form/Button";
import {usePermissions} from "../../resources/PermissionsHook";
import {ContentContainer} from "../../../../lib/src/components/content/ContentContainer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import {useMemo, useState} from "react";
import moment from "moment";
import {SectionHeader} from "../../../../lib/src/components/content/SectionHeader";
import {Input} from "../../../../lib/src/components/form/Input";
import {useNavigate} from "react-router-dom";

export const TussenOnsBroadcastListPage = () => {
  const {broadcasts: broadcastsApi} = useApiCall(config)
  const {resource: broadcasts, isLoading} = useApiEndpoint(() => broadcastsApi.browseUserBroadcasts())
  const {canManageBroadcasts} = usePermissions()

  const [search, setSearch] = useState<string>('')

  const filteredBroadcasts = useMemo(() => {
    return (broadcasts ?? [])
      .sort((a,b) => b.updated_at.localeCompare(a.updated_at))
      .filter(b => search.trim() === '' || b.subject.toLowerCase().includes(search.trim().toLowerCase()) || b.message.toLowerCase().includes(search.trim().toLowerCase()))
  }, [broadcasts, search])

  const broadcastYears = useMemo(() => {
    return Array.from(new Set((filteredBroadcasts).map(b => moment(b.updated_at).year()))).sort().reverse()
  }, [filteredBroadcasts])

  const navigate = useNavigate()

  return <ContentContainer size={'sm'}>
    <div className={'flex items-start justify-between'}>
      <PageHeader>Nieuws (Archief)</PageHeader>
      {canManageBroadcasts && <Button type={'primary'} size={'sm'} text={'Nieuws-publicaties Beheren'} onClick={() => navigate(`/broadcasts`)}/>}
    </div>

    <div className={'mb-8 -mt-4'}>
      <Input label={'Zoeken'} maxWidth={'full'} placeholder={'Zoeken...'} type={'search'} value={search} onChange={setSearch} />
    </div>

    {(broadcasts !== undefined && !isLoading) ? <>
      {broadcasts.length === 0 ? <>
        <div className={'border border-brand-primary-container rounded-lg px-4 py-4 text-brand-secondary flex items-center'}>
          <FontAwesomeIcon icon={faCircleCheck} />
          <div className={'font-medium ml-4'}>
            Er zijn geen nieuwsbrieven
          </div>
        </div>
      </> : <></>}
      {broadcastYears.map((y,i) => {
        return <div key={i} className={'grid grid-cols-1 gap-4 mb-12'}>
          <SectionHeader>{y}</SectionHeader>
          {filteredBroadcasts.filter(b => moment(b.updated_at).year() === y).map((b, j) => {
            return <TussenOnsBroadcastCard
              broadcast={b}
              unread={b.is_unread ?? false}
              key={j}
            />
          })}
        </div>
      })}
      <div>

      </div>
    </> :<TussenOnsBroadcastCard broadcast={null} unread={false} />}
  </ContentContainer>
}